import { useOutletContext, useParams } from "react-router";
import styled from "styled-components";

import AssignedParameters from "./AssignedParameters";
import ParameterGroupEditor from "./ParameterGroupEditor";
import ParameterGroupTitle from "./ParameterGroupTitle";
import { CssSectionCard } from "../../../components/styles";

import type { ParameterGroupOutletContext } from "../WithParameterGroupInventory";


const StyledParameterGroupDetail = styled.div`
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 20px;
    height: 100%;
    overflow: hidden;

    .section-card {
        ${ CssSectionCard }
    }
`;

export default function ParameterGroupDetail() {
    const { parameterGroupID } = useParams();
    const guard = useOutletContext<ParameterGroupOutletContext>();

    return (
        <StyledParameterGroupDetail>
            {/* Column 1: Header & Editor */}
            <div className="section-card">
                <ParameterGroupTitle
                    id={ parameterGroupID }
                />
                <ParameterGroupEditor
                    guard={ guard }
                    id={ parameterGroupID }
                    key={ parameterGroupID }
                />
            </div>

            {/* Column 2: Assigned Parameters */}
            <div className="section-card">
                <AssignedParameters
                    id={ parameterGroupID }
                />
            </div>
        </StyledParameterGroupDetail>
    );
}
